export const fadeIn = (element: HTMLElement, callback?: (elm: HTMLElement) => void) => {
  let counter = 0;
  const step = 4;
  let id: number;

  const run = () => {
    if (counter >= 100) {
      window.cancelAnimationFrame(id);

      if (callback) {
        callback(element);
      }
    } else {
      counter += step;
      element.style.opacity = (counter / 100).toString();
      id = window.requestAnimationFrame(run);
    }
  };

  id = window.requestAnimationFrame(run);
};

export const fadeOut = (element: HTMLElement, callback?: (elm: HTMLElement) => void) => {
  let counter = 100;
  const step = 4;
  let id: number;

  const run = () => {
    if (counter <= 0) {
      window.cancelAnimationFrame(id);

      if (callback) {
        callback(element);
      }
    } else {
      counter -= step;
      element.style.opacity = (counter / 100).toString();
      id = window.requestAnimationFrame(run);
    }
  };

  id = window.requestAnimationFrame(run);
};
